import React from 'react'
import {Link} from "react-router-dom";
import { toPrice } from '../../../reusable'
import { backgroundColorCounter } from '../style'
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from 'react-i18next';
// Import Swiper styles
import "swiper/swiper.min.css";

// import Swiper core and required modules
import SwiperCore, {
  Pagination, Navigation
} from 'swiper/core';

// install Swiper modules
SwiperCore.use([Pagination, Navigation]);

interface Text {
  fr : string
  en : string
}
interface RoomItem {
    id: number
    title : Text
    description : Text
    guest : number
    size: number
    price: number
    badge: string
    image: string
}

const Rooms = ({items}) => {
    const { t,i18n } = useTranslation();

    function addBadge(badge:string) {
        if(badge!=='' && badge!== null)
        return<div className="knsl-badge">{badge}</div>
    }

    function roomItem(item : RoomItem) {
        return(
            <SwiperSlide key={item.id}>
              <div className="knsl-room-card knsl-scroll-animation">
                <div className="knsl-cover-frame">
                  <Link to={`/room?id=${item.id}`}><img src={item.image} alt={`Room ${item.title[i18n.language]}, ${item.guest} Guests - The West Heaven Hotel`} /></Link>
                  {addBadge(item.badge)}
                </div>
                <div className="knsl-description-frame">
                  <div className="knsl-room-features">
                    <div className="knsl-feature">
                      <div className="knsl-icon-frame"><img src="assets/img/icons/bed.svg" alt="icon" /></div>
                      <span>{item.guest} Guests</span>
                    </div>
                    <div className="knsl-feature">
                      <div className="knsl-icon-frame"><img src="assets/img/icons/square.svg" alt="icon" /></div>
                      <span>{item.size} Ft²</span>
                    </div>
                  </div>
                  <Link to={`/room?id=${item.id}`}>
                    <h3 className="knsl-mb-20">{item.title[i18n.language]}</h3>
                  </Link>
                  <div className="knsl-text-light knsl-text-sm knsl-mb-20">{item.description[i18n.language]}</div>
                  <div className="knsl-card-bottom">
                    <div className="knsl-price">{toPrice(item.price)} xaf<span>/night</span></div>
                    <Link to={`/room?id=${item.id}`} className="knsl-btn"><img src="assets/img/icons/bookmark.svg" alt="icon" style={{height: 'auto'}} />Book now</Link>
                  </div>
                </div>
              </div>
            </SwiperSlide>
        )
    }  

    return (
        <section className="knsl-transition-bottom" style={backgroundColorCounter}>
          <img src="img/palm.svg" className="knsl-deco-left" alt="palm" />
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">

                <div className="knsl-center knsl-title-frame knsl-scroll-animation knsl-mb-100">
                  <h2 className="knsl-mb-20">{t('main.ourBestRooms')}</h2>
                  <p className="knsl-mb-30">{t('main.ourBestRoomsDesc')}</p>
                  <Link to="/rooms" className="knsl-btn knsl-btn-md">{t('main.allRooms')}</Link>
                </div>

              </div>
            </div>
          </div>
          <div className="swiper-container knsl-uni-slider">
                  <Swiper 
                    slidesPerView={1} 
                    spaceBetween={20} 
                    parallax={true} 
                    updateOnWindowResize={true} initialSlide={1} 
                    speed={800} 
                    breakpoints={{1600 : {slidesPerView: 4}, 1200 : {slidesPerView: 3}, 760 : {slidesPerView: 2}} } 
                    centeredSlides={true}
                    pagination={{el: '.knsl-uni-slider-pagination',type: "fraction",}}
                    navigation={{prevEl: '.knsl-uni-slider-prev',nextEl: '.knsl-uni-slider-next'}}
                  >
                    {items.map((item: RoomItem) => roomItem(item))}

                    {/* <!-- slider navigation --> */}
                    <div className="container">
                      <div className="knsl-uni-slider-nav-panel">
                        {/* <!-- pagination --> */}
                        <div className="knsl-uni-slider-pagination" style={{marginLeft: '30px'}}></div>
                        {/* <!-- navigation --> */}
                        <div className="knsl-uni-nav" style={{marginRight: '30px'}}>
                          <div className="knsl-uni-slider-prev"><i className="fas fa-arrow-left" ></i></div>
                          <div className="knsl-uni-slider-next"><i className="fas fa-arrow-right"></i></div>
                        </div>
                        {/* <!-- navigation end --> */}
                      </div>
                    </div>
                    {/* <!-- slider navigation end --> */}
                  </Swiper>
          </div>
        </section>
    )
}

export default Rooms